<template>
    <div class="container">
        <div class="grid grid-cols-12">
            <div class="col-span-12 lg:col-span-8 lg:col-start-3">
                <SectionIntro v-if="model.title" class="mt-14 lg:mt-20" lg :title="model.title" />
                <div v-if="model.text" class="tinymce-content mt-8 lg:mt-12" v-html="model.text"></div>
            </div>
        </div>
        <ScrollToTopButton />
    </div>
</template>

<script>
import ScrollToTopButton from '@/components/UI/Buttons/ScrollToTopButton.vue';

export default {
    name: 'Slug',
    components: { ScrollToTopButton },

    async asyncData({ $axios, params, error, app }) {
        let model = null;

        try {
            await $axios
                .$get(`/page/${params.slug}`)
                .then((res) => {
                    console.log(res);
                    if (res) {
                        model = res.data.translations[0];
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }

        if (!model) {
            return error({
                statusCode: 404,
                message: app.i18n.t('errors.page_not_found'),
            });
        }

        return {
            model,
        };
    },
    data() {
        return {
            model: null,
        };
    },
    head() {
        const meta = [
            {
                hid: 'og:title',
                property: 'og:title',
                content: this.model?.meta_title || this.model?.title,
            },
            {
                hid: 'title',
                name: 'title',
                content: this.model?.meta_title || this.model?.title,
            },
            {
                hid: 'og:description',
                property: 'og:description',
                content: this.model?.meta_description,
            },
            {
                hid: 'description',
                name: 'description',
                content: this.model?.meta_description,
            },
        ];

        return {
            title: this.model?.meta_title || this.model?.title,
            meta,
        };
    },
};
</script>
